import React from "react";
import { ReportNote } from "../../../features/reports/reportTypes";
import {
  ContainerLineItem,
  Layout,
  LoadingPlaceholder,
  Text,
  Padding,
  AnchorLink,
} from "@kidslivesafe/sc-react";

import { useCurrentBreakpoint } from "@kidslivesafe/sc-foundation";
import { parseDate } from "../../../utils";

interface NoteEntryProps {
  note: ReportNote | undefined;
  loading?: boolean;
  loadingKey?: string | number;
  onDelete?: () => void;
  onEdit?: () => void;
}

const NoteEntry: React.FC<NoteEntryProps> = ({
  note,
  onDelete,
  onEdit,
  loading = false,
  loadingKey,
}) => {
  const currentBreakpoint = useCurrentBreakpoint();

  const detailsSpacing = currentBreakpoint === "desktop" ? "md" : "xxs";
  // helper functions.

  return (
    <>
      {loading ? (
        <ContainerLineItem
          key={loadingKey}
          lineItemHeader={
            <LoadingPlaceholder width={"10rem"} height={"20px"} />
          }
          lineItemDetails={
            <Layout
              type="flex"
              flexProps={{ gap: detailsSpacing, alignItems: "center" }}
            >
              <LoadingPlaceholder width={"32px"} height={"32px"} />
              <div>
                <Layout
                  type="flex"
                  flexProps={{
                    gap: "xxs",
                    direction: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <LoadingPlaceholder width={"55px"} height={"13px"} />
                  <LoadingPlaceholder width={"50px"} height={"13px"} />
                </Layout>
              </div>
            </Layout>
          }
          lineItemSubHeader={<LoadingPlaceholder width={"12rem"} />}
        />
      ) : note ? (
        <Padding bottom="sm" top="sm">
          <Layout type="flex" flexProps={{ direction: "column", gap: "xs" }}>
            <Text size="sm" fontWeight="light">
              {note.note}
            </Text>
            <Layout
              type="grid"
              gridProps={{ templateColumns: "2-column", gap: "lg" }}
            >
              <Text size="sm" fontWeight="semibold">
                {note.dateModified
                  ? parseDate(note.dateModified, "month-day-year")
                  : parseDate(note.dateCreated, "month-day-year")}
              </Text>
              <Layout
                type="flex"
                flexProps={{ direction: "row", justifyContent: "flex-end" }}
              >
                <AnchorLink
                  handleClick={() => {
                    if (onDelete) {
                      onDelete();
                    }
                  }}
                  size="xs"
                  role="button"
                  hoverUnderline
                >
                  Delete
                </AnchorLink>
                <Text>|</Text>
                <AnchorLink
                  handleClick={() => {
                    if (onEdit) {
                      onEdit();
                    }
                  }}
                  size="xs"
                  role="button"
                  hoverUnderline
                >
                  Edit
                </AnchorLink>
              </Layout>
            </Layout>
          </Layout>
        </Padding>
      ) : null}
    </>
  );
};

export default NoteEntry;
